import { creatorbase } from '@round/api';
import { FormValues } from 'Modules/Plans/Finance/PaymentRequest/helpers';

// FormValues / Provider / validationSchema now live in the shared payment-request module so the
// campaign modal can reuse them. Re-exported here so existing post-side imports stay unchanged.
// TODO: Clean up with other component relocation
export type { FormValues, Provider, SubmitType } from 'Modules/Plans/Finance/PaymentRequest/helpers';
export { validationSchema } from 'Modules/Plans/Finance/PaymentRequest/helpers';

export const mapFormValuesToPatchData = (
    formValues: FormValues,
    feeConfigs?: creatorbase.ClientProviderFeeConfig[]
): Partial<creatorbase.PatchPostData> => {
    const provider = formValues.provider;
    return {
        base_cost: formValues.cost,
        currency_id: formValues.currency?.value,
        payment_info: {
            paypal_email_address: provider === 'PAYPAL' ? formValues.paypalEmail : undefined,
            client_payee_id: provider === 'TIPALTI' ? formValues.payee?.value : undefined,
            notes: formValues.notes ?? '',
        },
        fee_config_id: feeConfigs?.find((feeConfig) => feeConfig.provider_name === formValues.provider)
            ?.provider_fee_config_id,
        creator_agency_payee_id: provider === 'CREATOR_AGENCY' ? formValues.agencyPayee?.value : undefined,
        payment_request_file_upload: formValues.fileUpload,
    };
};
